export const PHONE_DISPLAY = "+45 71 41 87 05";
export const PHONE_TEL = "+4571418705";
export const EMAIL_DISPLAY = "Royal-solutions@hotmail.com";
export const EMAIL_HREF = "Royal-solutions@hotmail.com";

export const LOGO_EMBLEM = "/logo-crown-t.png";
export const ROSE_TL = "/rose-tl.png";
export const ROSE_TR = "/rose-tr.png";
export const ROSE_LIGHT_TL = "/rose-light-tl.png";
export const ROSE_LIGHT_TR = "/rose-light-tr.png";
export const ROSE_LIGHT_BL = "/rose-light-bl.png";
export const ROSE_LIGHT_BR = "/rose-light-br.png";
export const HERO_IMAGE = "/hero-table.png";
export const HERO_IMAGE_LIGHT = "/hero-table-light.png";

export const HERO_INTRO =
  "Vi leverer professionelle og skræddersyede løsninger inden for eventservice, rengøring, flyttehjælp, personale til fest & event, havearbejde, faste aftaler og meget mere – alt samlet ét sted for at gøre din hverdag nemmere, kvalitetssikret og stressfri.";

// Which pricing groups each service card shows on its dedicated /priser/:id page.
export const SERVICE_PRICING_MAP = {
  events: ["catering", "bar", "personale", "eventplanlaegning"],
  bryllupper: ["catering", "bar", "personale", "eventplanlaegning"],
  fester: ["catering", "bar", "personale", "eventplanlaegning"],
  personale: ["personale"],
  rengoring: ["rengoring"],
  havearbejde: ["havearbejde"],
  flyttehjaelp: ["flyttehjaelp"],
  fasteaftaler: [],
};

// Exact card images cropped from the brand poster.
export const SERVICES = [
  { id: "events", title: "Events", tagline: "Uforglemmelige oplevelser til enhver anledning", image: "/svc-events.png", action: "quote" },
  { id: "bryllupper", title: "Bryllupper", tagline: "Den perfekte dag i trygge hænder", image: "/svc-bryllupper.png", action: "quote" },
  { id: "fester", title: "Fester", tagline: "Uanset anledning skaber vi stemningen", image: "/svc-fester.png", action: "quote" },
  { id: "personale", title: "Personale til fest & event", tagline: "Tjenere · Bartendere · Eventpersonale · Opvaskere", image: "/svc-personale.png", action: "pricing" },
  { id: "rengoring", title: "Rengøring", tagline: "Rent miljø – større trivsel", image: "/svc-rengoring.png", action: "quote" },
  { id: "havearbejde", title: "Havearbejde", tagline: "Smukke uderum året rundt", image: "/svc-havearbejde.png", action: "quote" },
  { id: "flyttehjaelp", title: "Flyttehjælp", tagline: "Nemt, hurtigt og sikkert", image: "/svc-flyttehjaelp.png", action: "pricing" },
  { id: "fasteaftaler", title: "Faste aftaler", tagline: "Fast hjælp. Fleksible løsninger. Bedre muligheder.", image: "/svc-fasteaftaler.png", action: "quote" },
];

// Priced staffing roles (headline price incl. moms, per time). quote:true => "Få tilbud".
export const STAFFING_ROLES = [
  { id: "tjener", name: "Tjener", inclMoms: 399, unit: "/time" },
  { id: "bartender", name: "Bartender", inclMoms: 429, unit: "/time" },
  { id: "eventpersonale", name: "Eventpersonale", inclMoms: 389, unit: "/time" },
  { id: "opvasker", name: "Opvasker", inclMoms: 389, unit: "/time" },
  { id: "kokkenmedhjaelper", name: "Køkkenmedhjælper", inclMoms: 429, unit: "/time" },
];

// Flyttehjælp — per-item heavy-lifting surcharge tiers
export const MOVING_TIERS = [
  { id: "90-120", label: "90–120 kg", inclMoms: 500, note: "pr. genstand" },
  { id: "121-160", label: "121–160 kg", inclMoms: 700, note: "pr. genstand" },
  { id: "160+", label: "160 kg og derover", quote: true, note: "individuelt tilbud" },
];

export const NAV_LINKS = [
  { id: "forside", label: "Forside" },
  { id: "services", label: "Services" },
  { id: "priser", label: "Priser" },
  { id: "kontakt", label: "Kontakt" },
];
